// extracted by mini-css-extract-plugin
export const root = "page-header-module--root--3tJIw";
export const heading = "page-header-module--heading--34e8v";